export default "__VITE_ASSET__DFOiLe4X__"